export const AccountDetailsKey = 'account-details-jy0ee' // <-- DO NOT CHANGE THIS. The layout manager depends on this value.
